import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
  BrowserRouter
} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import App from './App';

// const router = createBrowserRouter([
//   { path: "/", element: <Login />, errorElement: <ErrorPage /> },
//   { path: "/register", element: <Register />, errorElement: <ErrorPage /> },
//   { path: "/dashboard", element: <Dashboard />, errorElement: <ErrorPage /> }
// ]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
